/* eslint-disable react/display-name */

import React from 'react';
import { Route } from 'react-router';

import Components from '../components';
import { redirectWhenRootPage } from '../lib/redirect';

export default () => {
  return (
    <Route>
      <Route path='/'>
        { redirectWhenRootPage() }
      </Route>
      <Route component={ Components.Reps.Active.Index } path='/reps/:id/active-rep' /> 
      <Route component={ Components.Layouts.App }>
        <Route component={ Components.PasswordResets.New } path='/password-resets/new' />
        <Route component={ Components.PasswordResets.Edit } path='/password-resets/:token/edit' />

        <Route component={ Components.Sessions.New } path='/login' />

        <Route component={ Components.Managers.SignUp.SignUp } path='/managers/new' />
        <Route component={ Components.Reps.New } path='/reps/new/:currentStep' />

        <Route component={ Components.Layouts.Manager }>
          <Route component={ Components.Managers.Profile.Edit } path='/managers/edit' />

          <Route component={ Components.Managers.Calendar.Index } path='/managers/calendar' />

          <Route component={ Components.Managers.Doctors.Index } path='/managers/doctors' />

          <Route component={ Components.Managers.Reps.Index } path='/managers/reps' />
          <Route component={ Components.Managers.RecommendOffice.Index } path='/managers/recommend-office' />
        </Route>

        <Route component={ Components.Layouts.Rep }>
          <Route component={ Components.Reps.Settings.Edit } path='/reps/edit' />

          <Route component={ Components.Reps.Books.Index } path='/reps/books' />
          <Route component={ Components.Reps.Books.Show } path='/reps/books/:id' />
          <Route component={ Components.Reps.Appointments.Index } path='/reps/books/:id/appointments' />

          <Route component={ Components.Reps.Calendar.Index } path='/reps/calendar' />
          <Route component={ Components.Reps.Appointments.Show } path='/reps/calendar/:date/:id' />
          <Route component={ Components.Reps.TradePost.Index } path='/reps/trade-post' />
          <Route component={ Components.Reps.Premium.Features } path='/reps/premium-subscription' />
          <Route component={ Components.Reps.Premium.Features } path='/reps/trial-subscription' />
          <Route component={ Components.Reps.Premium.Index } path='/reps/purchase-subscription' />
        </Route>
      </Route>
    </Route>
  );
};



// WEBPACK FOOTER //
// ./app/config/routes.jsx